document.addEventListener('DOMContentLoaded', () => {
	const counterAboutUsPage = () => {
		const counterItems = document.querySelectorAll('.JScountNumber')
		const counterContainer = document.querySelector('.JScounter')
		if (!counterContainer || !counterItems.length) return

		const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3)

		const animateOne = (el) => {
			const finalNumber = parseInt(el.getAttribute('data-number'), 10)
			if (!Number.isFinite(finalNumber)) return

			const from = 0

			const duration = finalNumber < 50 ? 2500 : finalNumber < 200 ? 2300 : finalNumber < 1000 ? 2000 : 2500

			const startTime = performance.now()

			const tick = (now) => {
				const elapsed = now - startTime
				const t = Math.min(elapsed / duration, 1)
				const eased = easeOutCubic(t)


				const current = Math.round(from + (finalNumber - from) * eased)

				el.textContent = String(current)

				if (t < 1) requestAnimationFrame(tick)
				else el.textContent = String(finalNumber)
			}

			requestAnimationFrame(tick)
		}

		const observer = new IntersectionObserver(
			(entries, obs) => {
				entries.forEach((entry) => {
					if (!entry.isIntersecting) return

					counterItems.forEach(animateOne)

					obs.unobserve(entry.target)
				})
			},
			{ root: null, threshold: 0.5 },
		)

		observer.observe(counterContainer)
	}

	counterAboutUsPage()
}) // end
